/**
 * Whether a Frontegg access token belongs to a staff member acting as the user: Frontegg names the actor in an
 * `act` claim (the platform reads it the same way). Anything that is not a readable JWT is not an impersonation.
 */
export function isFronteggImpersonationToken(accessToken: string | null | undefined): boolean {
  const payload = accessToken?.split('.')[1];
  if (!payload) {
    return false;
  }

  try {
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const claims = JSON.parse(atob(base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=')));
    return Boolean(claims?.act?.sub);
  } catch {
    return false;
  }
}
